<template>
    <Modal v-if="shown"
           :title="$t('user.apiKeys.modal.newKey.title')"
           :close-on-click-outside="false"
    >
        <template v-slot:body>
            <form class="flex flex_column modal-content">
                <md-field>
                    <label>{{ $t("user.apiKeys.newKey") }}</label>
                    <md-textarea :value="form.clearTextKey" readOnly></md-textarea>
                </md-field>
            </form>
            <div class="text_left light_bg_color margin_top">
                <span class="font_bold">{{$t("common.hint")}}：</span>
                <br/>
                <span>{{$t("user.apiKeys.modal.hint.saveRequired")}}</span>
            </div>
            <div class="flex flex_end margin_top">
                <md-button class="md-primary" @click="show(false)">
                    {{$t("common.button.ok")}}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";

export default {
    components: { Modal },
    data() {
        return {
            shown: false,
            form: {
                clearTextKey: "",
            },
        };
    },
    methods: {
        show(value) {
            this.shown = value;
        },
        showWithData(clearTextKey) {
            this.form.clearTextKey = clearTextKey;
            this.show(true);
        },
    },
};
</script>